// extracted by mini-css-extract-plugin
module.exports = {"pageHeader":"DiscountsList_pageHeader__37Efx"};